export default "__VITE_ASSET__3f23636a__"